module.exports = __webpack_public_path__ + "static/img/003-4.b431b975.png";